<template>
  <div class="base-question">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'BaseQuestion'
}
</script>
<style lang="scss" scoped>
.base-question {
  height: 100%;
  .base-content {
    width: 50%;
    margin: 32px 0px;
  }

  @media (max-width: 768px) {
  .base-content {
    width: 100%;
  }
}
}
</style>
